export default class Sharing {
    constructor(component) {
        this.component = component;
        this.shareData = {
            title: this.component.getAttribute('data-sharing-title'),
            url: this.component.getAttribute('data-sharing-url')
        }
        
        this.init();
    }
    
    init() {
        this.component.addEventListener('click', async () => {
            try {
                await navigator.share(this.shareData)
            } catch (err) {
                console.warn(err);
            }
        });
    }
}